import * as React from 'react';

//declare var require: any

//const loading = require("../Assets/imgs/loading.png") as string;
class Lazy extends React.Component<any> {
    render() {
        return (
            <div className="centeredLoader">
            </div>
        )
    }
};
export default Lazy;